import { isNullOrUndefined } from 'common/util/utils';
import {
    AssessmentRunSession,
    AssessmentRunSessionContributor,
    AssessmentRunSessionContributorRole,
} from '../store/context/reducer';

export const getArSessionCandidateContributor = (assessmentRunSession: AssessmentRunSession): AssessmentRunSessionContributor => {
    if (isNullOrUndefined(assessmentRunSession)) {
        return null;
    }
    const { contributors } = assessmentRunSession;
    return contributors.find((contrib: AssessmentRunSessionContributor) => contrib.role === AssessmentRunSessionContributorRole.CANDIDATE);
};
